import { css } from '@emotion/react';

export const formStyles = {
  modalTitle: css({ marginTop: 0 }),
  fullWidthSpace: css({ display: 'flex', width: '100%' }),
  flexOne: css({ flex: 1 }),
  locationContainer: css({
    display: 'flex',
    marginBottom: 16,
    padding: 16,
    border: '1px solid #f0f0f0',
    borderRadius: 8,
  }),
  locationHeader: css({ display: 'flex' }),
  sectionTitle: css({ marginTop: 16 }),
};

export const originTypeOptions = [
  { value: 'seed', label: 'Из семян' },
  { value: 'cutting', label: 'Черенок' },
  { value: 'seedling', label: 'Саженец' },
  { value: 'division', label: 'Деление' },
  { value: 'graft', label: 'Прививка' },
  { value: 'layering', label: 'Отводок' },
  { value: 'bulb', label: 'Луковица / клубень' },
  { value: 'transplant_in', label: 'Пересадка (получение)' },
] as const;
